export const GET_CLOSED_LEADS_REQUEST = 'GET_CLOSED_LEADS_REQUEST';
export const GET_CLOSED_LEADS_SUCCESS = 'GET_CLOSED_LEADS_SUCCESS';
export const GET_CLOSED_LEADS_ERROR = 'GET_CLOSED_LEADS_ERROR';
